Shopify.formatMoney = function(cents, format) {
if (typeof cents == 'string') {
cents = cents.replace('.', '');
}
var value = '';
var placeholderRegex = /{{\s*(\w+)\s*}}/;
var formatString = (format || this.money_format);
function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
}
function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
        return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
}
switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
    case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
    case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
    case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
}
return formatString.replace(placeholderRegex, value);
};

(function () {
  ymmFunctionality = {
    selector: {
      ymmJsonFileLInk: window.custom.ymmFileLink,
      makeSelectElement: ".js-make",
      modelSelectElement: ".js-model",
      searchButton: "#searchForm",
      resultElement: ".js-ymm-result-area",
    },

    init: function () {
      console.log("Initializing YMM functionality...");
      this.searchButton = document.querySelector(this.selector.searchButton);
      this.makeSelectElement = document.querySelector(this.selector.makeSelectElement);
      this.modelSelectElement = document.querySelector(this.selector.modelSelectElement);
      this.resultElement = document.querySelector(this.selector.resultElement);
      this.bindEvents();
    },

    bindEvents: function () {
      const _this = this;
      const jsonFile = _this.selector.ymmJsonFileLInk;
    console.log('jsonFile ', jsonFile)
    
      fetch(jsonFile)
        .then((response) => response.json())
        .then((data) => {
          _this.allData = data;
          _this.populateMakeDropdown(); // Load Make dropdown on page load
          _this.restoreSelectedYMM(); // Restore previous selection
        });
    
      this.makeSelectElement.addEventListener("change", function () {
        _this.populateModelDropdown();
      });
    
      this.searchButton.addEventListener("click", function (event) {
        _this.getFilterProducts(event);
      });
    },
    restoreSelectedYMM: function () {
      const storedData = JSON.parse(localStorage.getItem("ymmSelected"));
    
      if (!storedData) {
        return; // No saved data, exit
      }
    
      // Select the saved Make
      const makeOptions = this.makeSelectElement.options;
      for (let option of makeOptions) {
        if (option.value === storedData.make) {
          option.selected = true;
          this.populateModelDropdown(); // Trigger model loading
          break;
        }
      }
    
      // Delay setting the Model selection to ensure models are populated
      setTimeout(() => {
        const modelOptions = this.modelSelectElement.options;
        for (let option of modelOptions) {
          if (option.value === storedData.model) {
            option.selected = true;
            break;
          }
        }
      }, 300);
    },
    
    populateMakeDropdown: function () {
      const makes = [...new Set(this.allData.map((item) => item.Make))]; // Get unique Makes
      this.makeSelectElement.innerHTML = '<option value="">Select Make</option>';

      makes.forEach((make) => {
        this.makeSelectElement.insertAdjacentHTML(
          "beforeend",
          `<option value="${make}">${make}</option>`
        );
      });

      console.log("Make dropdown loaded.");
    },

    populateModelDropdown: function () {
      const selectedMake = this.makeSelectElement.value;
      this.modelSelectElement.innerHTML = '<option value="">Select Model</option>';
      this.modelSelectElement.disabled = true;
    
      if (!selectedMake) {
        return;
      }
    
      const models = [
        ...new Set(this.allData.filter((item) => item.Make === selectedMake).map((item) => item.Model)),
      ]; // Get unique Models for selected Make
    
      if (models.length > 0) {
        this.modelSelectElement.disabled = false;
      }
    
      models.forEach((model) => {
        this.modelSelectElement.insertAdjacentHTML(
          "beforeend",
          `<option value="${model}">${model}</option>`
        );
      });
    
      console.log(`Model dropdown updated for Make: ${selectedMake}`);
    },

    getFilterProducts: function (event) {
      event.preventDefault();
      const selectedMake = this.makeSelectElement.value;
      const selectedModel = this.modelSelectElement.value;
      const filteredProducts = this.allData.filter(
        (item) => item.Make === selectedMake && item.Model === selectedModel
      );

      if (filteredProducts.length === 0) {
        alert("No products found for the selected Make and Model.");
        return;
      }

      const productHandles = filteredProducts.map((item) => item.Product);
      localStorage.setItem(
        "ymmSelected",
        JSON.stringify({ make: selectedMake, model: selectedModel, products: productHandles })
      );

      const redirectUrl = `${location.origin}/pages/ymm-result?q=${selectedMake}+${selectedModel}&options[prefix]=last`;
      console.log("Redirecting to:", redirectUrl);
      window.location.href = redirectUrl;
    },
  };

  ymmFunctionality.init();
})();


document.addEventListener("DOMContentLoaded", function () {
  const resetButton = document.getElementById("resetYMM");
  const makeDropdown = document.querySelector(".js-make");
  const modelDropdown = document.querySelector(".js-model");

  console.log('makeDropdown ', makeDropdown)

  // Function to check if it's the homepage
  function isHomePage() {
    return window.location.pathname === "/";
  }

  // Reset the dropdown selections only on the homepage
  if (isHomePage()) {
    makeDropdown.value = "";
    modelDropdown.innerHTML = '<option value="">Select Model</option>';
    modelDropdown.disabled = true;

    // Clear stored data in localStorage
    localStorage.removeItem("ymmSelected");

    console.log("YMM selections cleared on homepage.");
  }

  if (resetButton) {
    resetButton.addEventListener("click", function () {
      makeDropdown.value = "";
      modelDropdown.innerHTML = '<option value="">Select Model</option>';
      modelDropdown.disabled = true;
      localStorage.removeItem("ymmSelected");

      console.log("YMM selections cleared.");
    });
  }
});


